import { render, staticRenderFns } from "./editIconCategory.vue?vue&type=template&id=2daff082&scoped=true&"
import script from "./editIconCategory.vue?vue&type=script&lang=js&"
export * from "./editIconCategory.vue?vue&type=script&lang=js&"
import style0 from "./editIconCategory.vue?vue&type=style&index=0&id=2daff082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daff082",
  null
  
)

export default component.exports